/* eslint-disable */

/**
 * Create styles for `<Footer />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<Footer />` styles
 */
const footerStyles = ({ isLight, theme }) => ({
  topFooter: {
    color: theme.palette.grey[500],
    [theme.breakpoints.down(`sm`)]: {
      width: `100%`,
    },
  },
});

export default footerStyles;
